jQuery(document).ready(function($){

    $.each($(".tb-puffs, .tb-booking-puffs"), function() {
        var src = "";
        var container = $(this).find(".img-container");

        if($(this).width() > 400) {
            src = container.data("imgnormal");
            if(src === "") {
                src = container.data("imgsquare");
            }
        } else {
            src = container.data("imgsquare");
            if(src === "") {
                src = container.data("imgnormal");
            }
        }

        container.css({
            "background-image": "url('" + src + "')"
        })

    })
});
